import React from 'react';
import { StyledSpinner } from '../../styled-spinner/styled-spinner';
import { VouchersPopupLayer } from './componentes/vouchers-popup-layer';
import { VouchersCarousel } from './componentes/vouchers-carousel';
import { GetPersonUser, NormalizedVoucher, PersonBenefits, normalizeVouchers } from '@esportal/portal-service';

export const Vouchers = ({
	personBenefits,
	vouchersRef,
	userData,
}: {
	personBenefits: PersonBenefits;
	vouchersRef: React.RefObject<HTMLElement>;
	userData: GetPersonUser | null;
}): React.ReactElement => {
	//To implement a tracking that shows how many Bonus a user has. It would be necessary to add a new tracking event
	// const trackingManager = useTrackingManager();

	// const [isTracked, setIsTracked] = useState(false);
	const normalizedVouchers = normalizeVouchers(personBenefits);
	const [isVouchersPopupVisible, setIsVouchersPopupVisible] = React.useState<boolean>(false);
	const [vouchersPopupData, setVouchersPopupData] = React.useState<NormalizedVoucher | undefined>(undefined);

	//To implement a tracking that shows how many Bonus a user has. It would be necessary to add a new tracking event

	// useEffect(() => {
	// 	const handleScroll = () => {
	// 		if (!elementRef.current || isTracked) {
	// 			return;
	// 		}

	// 		const rect = elementRef.current.getBoundingClientRect();

	// 		const isVisible =
	// 			rect.top >= 0 &&
	// 			rect.left >= 0 &&
	// 			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
	// 			rect.right <= (window.innerWidth || document.documentElement.clientWidth);

	// 		if (isVisible && filteredBonus) {
	// 			trackingManager.trackClubVWGenericFeatureAppLoad({ contentId: `${filteredBonus.length} bonus` });
	// 			setIsTracked(true);
	// 		}
	// 	};

	// 	window.addEventListener('scroll', handleScroll);
	// 	handleScroll();

	// 	return () => {
	// 		window.removeEventListener('scroll', handleScroll);
	// 	};
	// }, [filteredBonus, isTracked]);

	return (
		<>
			<VouchersPopupLayer
				className="vouchers__popup"
				vouchersPopupData={vouchersPopupData}
				isVouchersPopupVisible={isVouchersPopupVisible}
				setIsVouchersPopupVisible={setIsVouchersPopupVisible}
				vouchersLayerRef={vouchersRef}
				userData={userData}
			/>
			{normalizedVouchers ? (
				<>
					<VouchersCarousel
						normalizedVouchers={normalizedVouchers || []}
						showButton={true}
						setVouchersPopupData={setVouchersPopupData}
						setIsVouchersPopupVisible={setIsVouchersPopupVisible}
					/>
				</>
			) : (
				<StyledSpinner variant="x-large" />
			)}
		</>
	);
};
